import {
  AddBusinessOutlined,
  AddRounded,
  EditNoteOutlined,
  PersonAddOutlined,
} from "@mui/icons-material";
import { lazy, Suspense, useCallback } from "react";
import { useDispatch } from "react-redux";

import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { sidebarTypeToggle } from "../../../redux/actions/sidebarActions";
import LoadingFallback from "../../../components/LoadingFallback";

const DropdownButton = lazy(
  () => import("../../../components/ui/buttons/DropdownButton")
);

const AddToLoanDropdownButton = () => {
  const dispatch = useDispatch();

  const handleAddBorrower = useCallback(() => {
    dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.ADD_BORROWER));
  }, [dispatch]);

  const handleAddProperty = useCallback(() => {
    dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.ADD_PROPERTY));
  }, [dispatch]);

  const handleAddException = useCallback(() => {
    dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.ADD_EXCEPTION));
  }, [dispatch]);

  const options = [
    {
      label: "Add Borrower",
      onClick: handleAddBorrower,
      icon: <PersonAddOutlined />,
    },
    {
      label: "Add Property",
      onClick: handleAddProperty,
      icon: <AddBusinessOutlined />,
    },
    {
      label: "Add Exception",
      onClick: handleAddException,
      icon: <EditNoteOutlined className="thin" />,
    },
  ];

  return (
    <>
      <Suspense fallback={<LoadingFallback />}>
        <DropdownButton
          size="small"
          // size="large"
          endIcon={<AddRounded />}
          variant="outlined"
          options={options}
        >
          Add New
        </DropdownButton>
      </Suspense>
    </>
  );
};

export default AddToLoanDropdownButton;
